import { ReactNode, useState } from "react";
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  Container,
  Divider,
  Drawer,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";

import {
  Menu as MenuIcon,
  Dashboard,
  Notifications,
} from "@mui/icons-material";
import { Outlet, useNavigate } from "react-router-dom";
import { RootState } from "../../Store/store";
import { Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import APP_ROUTES from "../../Configurations/APP_ROUTES";

const drawerWidth = 240;

interface IAdminLayout {
  children?: ReactNode;
  adminAuth?: any;
}

const AdminLayout = (props: IAdminLayout) => {
  const { adminAuth } = props;
  const navigation = useNavigate();

  const { tabs } = adminAuth;

  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  console.log(adminAuth, "adminAuth");

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [...tabs];

  const handleMenuNavigation = (itme: any) => {
    if (itme && itme?.name === "APN Uploads") {
      navigation(APP_ROUTES.ADMIN_APN_UPLOAD.pathname.toString(), {
        replace: true,
      });
    }
    if (itme && itme?.name === "Dashboard") {
      navigation(APP_ROUTES.ADMIN_DASHBOARD.pathname.toString(), {
        replace: true,
      });
    }
  };

  const drawer = (
    <div>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton onClick={() => handleMenuNavigation(item)}>
              <ListItemIcon>
                <Dashboard />
              </ListItemIcon>
              <ListItemText sx={{ fontWeight: "bold" }} primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <Container maxWidth={"xl"} disableGutters>
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
      <AppBar
        // position="fixed"
        sx={{
          position: "relative", // This makes the AppBar position relative to its container
          width: "100%", // This constrains the width to its parent container
          maxWidth: "inherit", // This ensures it doesn't exceed the container's max width
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            Admin Dashboard
          </Typography>

          {/* Notifications */}
          <IconButton color="inherit" sx={{ mr: 1 }}>
            <Badge badgeContent={3} color="error">
              <Notifications />
            </Badge>
          </IconButton>

          {/* Avatar + Menu */}
          <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
            <Avatar alt="Admin User" src="/static/images/avatar/1.jpg" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={openMenu}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Settings</MenuItem>
            <Divider />
            <MenuItem onClick={handleMenuClose}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Box>
        <Grid2 container>
          <Grid2 size={{ lg: 2, md: 3 }}>
            <Box
              display={{
                xl: "block",
                lg: "block",
                md: "block",
                sm: "none",
                xs: "none",
              }}
            >
              {drawer}
            </Box>
          </Grid2>
          <Grid2 size={{ lg: 10, md: 9 }}>
            <Box p={"16px"}>
              <Outlet />
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </Container>
  );
};

function mapStateToProps(state: RootState) {
  return {
    adminAuth: state.adminAuth,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {};
}

// export default AdminLayout;

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);
